module.exports = __webpack_public_path__ + "static/media/cross-hover.88abef6b.svg";